"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = void 0;
var Spacing;
(function (Spacing) {
    Spacing["s0"] = "0px";
    Spacing["s2"] = "2px";
    Spacing["s4"] = "4px";
    Spacing["s8"] = "8px";
    Spacing["s10"] = "10px";
    Spacing["s12"] = "12px";
    Spacing["s14"] = "14px";
    Spacing["s16"] = "16px";
    Spacing["s20"] = "20px";
    Spacing["s24"] = "24px";
    Spacing["s32"] = "32px";
    Spacing["s40"] = "40px";
    Spacing["s48"] = "48px";
    Spacing["s56"] = "56px";
    Spacing["s64"] = "64px";
    Spacing["s72"] = "72px";
    Spacing["s80"] = "80px";
    Spacing["s88"] = "88px";
    Spacing["s96"] = "96px";
    Spacing["s104"] = "104px";
    Spacing["s112"] = "112px";
    Spacing["s120"] = "120px";
    Spacing["s128"] = "128px";
})(Spacing || (exports.Spacing = Spacing = {}));
//# sourceMappingURL=Spacing.js.map